import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { MembershipFormData, DataService, Leadership } from '../../bpg-common/services/data.services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-bpg-demographics',
  templateUrl: './bpg-demographics.component.html',
  styleUrls: ['./bpg-demographics.component.css']
})
export class BpgDemographicsComponent implements OnInit {
  demographicsList: any[] = [];
  selectedDemographics: any[] = [];
  savedData: any;
  interestList: any[];
  bpgList: any[];
  formData: MembershipFormData[];
  skillsList: any[] = [];
  leadershipList: Leadership = new Leadership();
  otherSKills: string;
  savedMembershipForm: any;
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;

    /** @class BpgDemographicsComponent
   * @constructor
   */
  constructor(private readonly membershipService: BpgMembershipService, private readonly data: DataService,private readonly spinnerService: Ng4LoadingSpinnerService,  private readonly router: Router,private readonly environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }
    }
    this.formData = [];

    this.data.savedData.subscribe(savedData =>
      this.savedData = savedData
    )
    this.data.savedMembershipForm.subscribe(savedMembershipForm  => this.savedMembershipForm= savedMembershipForm )

    this.spinnerService.show();
    if (this.savedData[0].skillsFormData !== undefined) {
      this.skillsList = this.savedData[0].skillsFormData;
    } else {
      this.skillsList = [];
    }
    if (this.savedData[0].bpgFormData !== undefined) {
      this.bpgList = this.savedData[0].bpgFormData;
    } else {
      this.bpgList = [];
    }
    if (this.savedData[0].interestFormData !== undefined) {
      this.interestList = this.savedData[0].interestFormData;
    } else {
      this.interestList = [];
    }
    if (this.savedData[0].leadershipFormData !== undefined) {
      this.leadershipList = this.savedData[0].leadershipFormData;
    } else {
      this.leadershipList = null;
    }
    if (this.savedData[0].otherSkillsFormData !== undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }
    
    this.membershipService.getDemographics().subscribe(data => {
      this.demographicsList = data;
      this.spinnerService.hide();


      if (this.savedData[0].demographicsFormData !== undefined) {
        if (this.savedData[0].demographicsFormData.length > 0) {
          for (let i = 0, len = this.demographicsList.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].demographicsFormData.length; j < len; j++) {
              if (this.demographicsList[i].demograhicId === this.savedData[0].demographicsFormData[j].demograhicId) {
                this.demographicsList[i].checked = true;
                this.selectedDemographics.push(this.demographicsList[i]);
              }
            }
          }
        }
        else if(this.savedMembershipForm.demographicIds.length>0){
          for (let i = 0, len = this.demographicsList.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.demographicIds.length; j < len; j++) {
              if (this.demographicsList[i].demograhicId === this.savedMembershipForm.demographicIds[j]) {
                this.demographicsList[i].checked = true;
                this.selectedDemographics.push(this.demographicsList[i]);
              }
            }
          }
        }
      }
    }, err => {
      this.spinnerService.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    });

  }

  /** to select the checkbox
   * @class BpgDemographicsComponent
   * @method toggleCheckbox
   */
  toggleCheckbox(event, data) {
    if (event.target.checked) {
      this.selectedDemographics.push(data);
    } else {
      const index: number = this.selectedDemographics.indexOf(data);
      if (index !== -1) {
        this.selectedDemographics.splice(index, 1);
      }
    }
  }

  /** To send data to next page
   * @class BpgDemographicsComponent
   * @method saveData
   */
  public saveData() {
    //demographic code comment
    this.data.saveData(this.formData);
    window.scrollTo(0, 0)
  }

  /** To send data to previous page
   * @class BpgDemographicsComponent
   * @method redirectToBpg
   */
  public redirectToBpg() {
    //demographic code comment
    this.data.saveData(this.formData);
    window.scrollTo(0, 0)
  }

  /**skips the selected data and goes to next page
   * @class BpgDemographicsComponent
   * @method skipDemographics
   */
  public skipDemographics() {
   //demographic code comment
    this.data.saveData(this.formData);
    window.scrollTo(0, 0)
  }

}
